import clsx from "clsx";

import { HeadingProps } from "./types";
import * as styles from "./styles.module.scss";

type Props = HeadingProps;

export function Heading({ level, className, children, id }: Props) {
  const additionStyles = typeof className !== "undefined" ? className : "";

  function renderProperHeading() {
    switch (level) {
      case 1:
        return (
          <h1 className={clsx(styles.h1, additionStyles)} id={id}>
            {children}
          </h1>
        );
      case 2:
        return (
          <h2 className={clsx(styles.h2, additionStyles)} id={id}>
            {children}
          </h2>
        );
      case 3:
        return (
          <h3 className={clsx(styles.h3, additionStyles)} id={id}>
            {children}
          </h3>
        );
      case 4:
        return (
          <h4 className={clsx(styles.h4, additionStyles)} id={id}>
            {children}
          </h4>
        );
      case 5:
        return (
          <h5 className={clsx(styles.h5, additionStyles)} id={id}>
            {children}
          </h5>
        );
      case 6:
        return (
          <h6 className={clsx(styles.h6, additionStyles)} id={id}>
            {children}
          </h6>
        );
      default:
        return (
          <h1 className={`${styles.h1} ${additionStyles}`} id={id}>
            {children}
          </h1>
        );
    }
  }

  return renderProperHeading();
}
